module.exports = __webpack_public_path__ + "h5/img/shop_logo.e7916a75.png";